import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Linker from '@/components/base/Linker';
import Icon from '@/components/base/Icon';
import { makeAddressInfo, makeBlockDetailLink } from '@/utils/link';
import { gettext } from '@/utils/langsBook';
import { toDio, toShard } from '@/utils/string';
import Tooltip from '@/components/base/Tooltip';
import IntervalTime from '@/components/combined/IntervalTime';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var BlockItemStyled = styled.div.withConfig({
    displayName: "Block__BlockItemStyled",
    componentId: "sc-iog941-0"
})([
    "",
    " a{",
    "}p{",
    "}.diox-font{",
    "}span{",
    "}"
], {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "baseline"
}, {
    "color": "var(--color-text-primary)",
    "textAlign": "left"
}, {
    "fontSize": "15px",
    "textAlign": "left"
}, {
    "marginRight": "8px",
    "fontSize": "16px"
}, {
    "color": "var(--color-desc-text)",
    "fontSize": "13px",
    "lineHeight": "21px",
    "verticalAlign": "middle"
});
export var masterBlockColumns = [
    {
        key: 'time',
        width: 183,
        render: function(row) {
            /*#__PURE__*/ return _jsxs(BlockItemStyled, {
                children: [
                    /*#__PURE__*/ _jsx(Linker, {
                        className: "text-[15px] mb-[6px] leading-[18px]",
                        href: makeBlockDetailLink(row.Hash),
                        text: String(row.Height),
                        cancelBubble: true
                    }),
                    /*#__PURE__*/ _jsx(IntervalTime, {
                        time: row.Timestamp
                    })
                ]
            });
        }
    },
    {
        key: 'Executed Txns',
        className: '!pl-[0]',
        render: function(row) {
            /*#__PURE__*/ return _jsx(BlockItemStyled, {
                className: "items-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "auto",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "mb-[6px] leading-[18px]",
                            children: row.NumExecutedTxns
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: gettext('Executed Txns')
                        })
                    ]
                })
            });
        }
    },
    {
        key: 'Emitted Txns',
        className: '!pl-[0]',
        render: function(row) {
            /*#__PURE__*/ return _jsx(BlockItemStyled, {
                className: "items-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "auto",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "mb-[6px] leading-[18px]",
                            children: row.NumEmittedTxns
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: gettext('Emitted Txns')
                        })
                    ]
                })
            });
        }
    },
    {
        key: 'Address',
        width: 190,
        render: function(row) {
            /*#__PURE__*/ return _jsxs(BlockItemStyled, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "first flex items-center text-desc mb-[6px]",
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                type: "profile"
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {
                                overlay: /*#__PURE__*/ _jsx("div", {
                                    className: "text-[13px] text-desc font-mono",
                                    children: row.MinerAddress
                                }),
                                placement: "top",
                                children: /*#__PURE__*/ _jsx(Linker, {
                                    className: "text-[14px]",
                                    href: makeAddressInfo(row.MinerAddress),
                                    text: row.MinerAddress,
                                    isAddress: true,
                                    cancelBubble: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center text-desc",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                type: "reward"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "!text-[14px]",
                                children: toDio(row.Reward, true, 2)
                            })
                        ]
                    })
                ]
            });
        }
    }
];
var widthTypes = {
    default: [
        220,
        220,
        240,
        200
    ],
    block: [
        225,
        100,
        140,
        140,
        140,
        150,
        130,
        164,
        174
    ],
    blockDetail: [
        166,
        158,
        158,
        158,
        158,
        158,
        158,
        152,
        94
    ]
};
export var getShardBlockNormalColumns = function() {
    return [
        {
            key: 'time',
            title: gettext('Height'),
            width: widthTypes.block[0],
            className: '!pl-[68px]',
            render: function(row) {
                /*#__PURE__*/ return _jsxs(BlockItemStyled, {
                    children: [
                        /*#__PURE__*/ _jsx(Linker, {
                            className: "text-[15px] mb-[6px] leading-[18px]",
                            href: makeBlockDetailLink(row.Hash),
                            text: String(row.Height),
                            cancelBubble: true
                        }),
                        /*#__PURE__*/ _jsx(IntervalTime, {
                            time: row.Timestamp
                        })
                    ]
                });
            }
        },
        {
            key: 'Scheduled',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "Scheduled",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('Scheduled')
                    })
                ]
            }),
            width: widthTypes.block[1],
            className: '!pl-[0]',
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumScheduledTxns
                    })
                });
            }
        },
        {
            key: 'UserInitiated',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "UserInitiated",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('UserInitiated')
                    })
                ]
            }),
            width: widthTypes.block[2],
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumUserInitiatedTxns
                    })
                });
            }
        },
        {
            key: 'Intra Relay',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "IntraRelay",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('Intra Relay')
                    })
                ]
            }),
            width: widthTypes.block[3],
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumIntraRelayTxns
                    })
                });
            }
        },
        {
            key: 'Inbound Relay',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "InboundRelay",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('Inbound Relay')
                    })
                ]
            }),
            width: widthTypes.block[4],
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumInboundRelayTxns
                    })
                });
            }
        },
        {
            key: 'Outbound Relay',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "OutboundRelay",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('Outbound Relay')
                    })
                ]
            }),
            width: widthTypes.block[5],
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumOutboundRelayTxns
                    })
                });
            }
        },
        {
            key: 'Deferred Relay',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "DeferredRelay",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('Deferred Relay')
                    })
                ]
            }),
            width: widthTypes.block[6],
            className: '!pl-[30px]',
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumDeferredRelayTxns
                    })
                });
            }
        },
        {
            key: 'Dispatched Relay',
            title: /*#__PURE__*/ _jsxs("div", {
                className: "ex-icon-th ml-[-20px]",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "DispatchedRelay",
                        className: "icon"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text",
                        children: gettext('Dispatched Relay')
                    })
                ]
            }),
            width: widthTypes.block[7],
            render: function(row) {
                /*#__PURE__*/ return _jsx(BlockItemStyled, {
                    children: /*#__PURE__*/ _jsx("p", {
                        children: row.NumDispatchedRelayTxns
                    })
                });
            }
        },
        {
            key: 'Address',
            title: gettext('Miner'),
            width: widthTypes.block[8],
            render: function(row) {
                /*#__PURE__*/ return _jsxs(BlockItemStyled, {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "first flex items-center text-desc mb-[6px]",
                            onClick: function(e) {
                                return e.stopPropagation();
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "profile"
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    overlay: /*#__PURE__*/ _jsx("div", {
                                        className: "text-[13px] text-desc font-mono",
                                        children: row.MinerAddress
                                    }),
                                    placement: "top",
                                    children: /*#__PURE__*/ _jsx(Linker, {
                                        className: "text-[14px]",
                                        href: makeAddressInfo(row.MinerAddress),
                                        text: row.MinerAddress,
                                        isAddress: true,
                                        cancelBubble: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center text-desc",
                            children: [
                                /*#__PURE__*/ _jsx(Icon, {
                                    type: "reward"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "!text-[14px]",
                                    children: toDio(row.Reward, true, 2)
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ];
};
export var shardBlockLooseColumns = [
    {
        key: 'Timestamp',
        width: 188,
        render: function(row) {
            /*#__PURE__*/ return _jsxs(BlockItemStyled, {
                children: [
                    /*#__PURE__*/ _jsx(Linker, {
                        href: makeBlockDetailLink(row.Hash),
                        text: String(row.Height),
                        cancelBubble: true
                    }),
                    /*#__PURE__*/ _jsx(IntervalTime, {
                        time: row.Timestamp,
                        className: "font-mono"
                    })
                ]
            });
        }
    },
    {
        key: 'Block Executed Txns',
        width: 140,
        className: '!pl-[0]',
        render: function(row) {
            /*#__PURE__*/ return _jsx(BlockItemStyled, {
                className: "items-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "auto",
                    children: [
                        /*#__PURE__*/ _jsxs("p", {
                            className: "mb-[6px] leading-[18px]",
                            children: [
                                " ",
                                row.NumExecutedTxns
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: gettext('Executed Txns')
                        })
                    ]
                })
            });
        }
    },
    {
        key: 'Block Emitted Txns',
        className: '!pl-[0]',
        render: function(row) {
            /*#__PURE__*/ return _jsx(BlockItemStyled, {
                className: "items-center",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "auto",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: "mb-[6px] leading-[18px]",
                            children: row.NumEmittedTxns
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: gettext('Emitted Txns')
                        })
                    ]
                })
            });
        }
    },
    {
        key: 'Address',
        width: 223,
        render: function(row) {
            /*#__PURE__*/ return _jsxs(BlockItemStyled, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "first flex items-center text-desc",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                className: "mr-[8px]",
                                type: "profile"
                            }),
                            /*#__PURE__*/ _jsx(Tooltip, {
                                overlay: /*#__PURE__*/ _jsx("div", {
                                    className: "text-[13px] text-desc font-mono",
                                    children: row.MinerAddress
                                }),
                                placement: "top",
                                children: /*#__PURE__*/ _jsx(Linker, {
                                    className: "text-[14px]",
                                    href: makeAddressInfo(row.MinerAddress),
                                    text: row.MinerAddress,
                                    cancelBubble: true,
                                    isAddress: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center text-desc",
                        children: [
                            /*#__PURE__*/ _jsx(Icon, {
                                className: "mr-[8px]",
                                type: "reward"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-[14px]",
                                children: toDio(row.GasFee, true)
                            })
                        ]
                    })
                ]
            });
        }
    }
];
export var makeShardBlockColumns = function(props) {
    var ref = props || {}, _expandable = ref.expandable, expandable = _expandable === void 0 ? 'default' : _expandable, isMaster = ref.isMaster, isMasterDetail = ref.isMasterDetail, _originData = ref.originData, originData = _originData === void 0 ? [] : _originData;
    var width = widthTypes[expandable];
    var column = [];
    if (isMaster) {
        column = [
            {
                key: 'Executed Txns',
                className: '!pl-[0]',
                render: function(row) {
                    /*#__PURE__*/ return _jsx("div", {
                        className: "items-center",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "auto",
                            children: /*#__PURE__*/ _jsxs("p", {
                                className: "leading-[18px] text-desc",
                                children: [
                                    " ",
                                    row.NumExecutedTxns
                                ]
                            })
                        })
                    });
                }
            },
            {
                key: 'Emitted Txns',
                className: '!pl-[0]',
                render: function(row) {
                    /*#__PURE__*/ return _jsx("div", {
                        className: "items-center",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "auto",
                            children: /*#__PURE__*/ _jsx("p", {
                                className: "leading-[18px] text-desc",
                                children: row.NumEmittedTxns
                            })
                        })
                    });
                }
            }
        ];
    } else {
        var NumScheduledTxns = 0;
        var NumUserInitiatedTxns = 0;
        var NumIntraRelayTxns = 0;
        var NumInboundRelayTxns = 0;
        var NumOutboundRelayTxns = 0;
        var NumDeferredRelayTxns = 0;
        var NumDispatchedRelayTxns = 0;
        var thClss = isMasterDetail ? '!pl-[0]' : '';
        originData.forEach(function(d) {
            NumScheduledTxns += d.NumScheduledTxns;
            NumUserInitiatedTxns += d.NumUserInitiatedTxns;
            NumIntraRelayTxns += d.NumIntraRelayTxns;
            NumInboundRelayTxns += d.NumInboundRelayTxns;
            NumOutboundRelayTxns += d.NumOutboundRelayTxns;
            NumDeferredRelayTxns += d.NumDeferredRelayTxns;
            NumDispatchedRelayTxns += d.NumDispatchedRelayTxns;
        });
        column = [
            {
                key: 'Scheduled',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "Scheduled",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('Scheduled'),
                                " (",
                                NumScheduledTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[1] - (isMasterDetail ? 20 : 0),
                dataIndex: 'NumScheduledTxns',
                className: '!pl-[0]'
            },
            {
                key: 'UserInitiated',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "UserInitiated",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('UserInitiated'),
                                " (",
                                NumUserInitiatedTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[2] - (isMasterDetail ? 10 : 0),
                dataIndex: 'NumUserInitiatedTxns',
                className: thClss
            },
            {
                key: 'Intra Relay',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "IntraRelay",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('Intra Relay'),
                                " (",
                                NumIntraRelayTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[3] - (isMasterDetail ? 20 : 0),
                dataIndex: 'NumIntraRelayTxns',
                className: thClss
            },
            {
                key: 'Inbound Relay',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "InboundRelay",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('Inbound Relay'),
                                " (",
                                NumInboundRelayTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[4],
                dataIndex: 'NumInboundRelayTxns',
                className: thClss
            },
            {
                key: 'Outbound Relay',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "OutboundRelay",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('Outbound Relay'),
                                " (",
                                NumOutboundRelayTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[5],
                dataIndex: 'NumOutboundRelayTxns',
                className: thClss
            },
            {
                key: 'Deferred Relay',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "DeferredRelay",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('Deferred Relay'),
                                " (",
                                NumDeferredRelayTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[6],
                dataIndex: 'NumDeferredRelayTxns',
                className: thClss || '!pl-[30px]'
            },
            {
                key: 'Dispatched Relay',
                title: /*#__PURE__*/ _jsxs("div", {
                    className: "ex-icon-th ml-[-20px]",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            type: "DispatchedRelay",
                            className: "icon"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            className: "text",
                            children: [
                                gettext('Dispatched Relay'),
                                " (",
                                NumDispatchedRelayTxns,
                                ")"
                            ]
                        })
                    ]
                }),
                width: width[7],
                render: function(row) {
                    /*#__PURE__*/ return _jsx(BlockItemStyled, {
                        children: /*#__PURE__*/ _jsx("p", {
                            children: row.NumDispatchedRelayTxns || '--'
                        })
                    });
                },
                className: thClss
            }
        ];
    }
    return [
        {
            key: 'ShardIndex',
            title: gettext('Shard ID'),
            width: isMaster ? 224 : width[0],
            className: isMasterDetail ? '' : '!pl-[88px]',
            render: function(row) {
                /*#__PURE__*/ return _jsx(Linker, {
                    href: makeBlockDetailLink(row.Hash),
                    text: "".concat(row.Height).concat(toShard(row.ShardIndex)),
                    className: "text-[14px]"
                });
            }
        }
    ].concat(_toConsumableArray(column), [
        {
            title: gettext('Gas Fees'),
            width: isMaster ? 190 : 'auto',
            className: isMasterDetail ? '!pl-[0]' : isMaster ? '!pl-[41px]' : '!pl-[39px]',
            render: function(row) {
                /*#__PURE__*/ return _jsxs("p", {
                    className: "text-desc",
                    children: [
                        /*#__PURE__*/ _jsx(Icon, {
                            className: "mr-[8px] text-[16px]",
                            type: "reward"
                        }),
                        toDio(row.GasFee, true, 2)
                    ]
                });
            }
        }
    ]);
};
